import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["top", "right", "bottom", "left", "fill", "play"]

  connect() {
    // El controller está en el article (contenedor de la card)
    // Los eventos mouseenter/mouseleave se disparan solo al entrar/salir de la card completa
    this.element.addEventListener('mouseenter', this.handleMouseEnter.bind(this))
    this.element.addEventListener('mouseleave', this.handleMouseLeave.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('mouseenter', this.handleMouseEnter.bind(this))
    this.element.removeEventListener('mouseleave', this.handleMouseLeave.bind(this))
  }

  handleMouseEnter() {
    // Validar que todos los targets existen antes de proceder
    if (!this.hasAllTargets()) return

    // Cancelar cualquier animación de desdibujo pendiente
    this.cancelAnimations()

    // Dibujar en orden: top → right → bottom → left (180ms cada uno)
    this.animateLine(this.topTarget, 0, 180)
    this.animateLine(this.rightTarget, 180, 180)
    this.animateLine(this.bottomTarget, 360, 180)
    this.animateLine(this.leftTarget, 540, 180)

    // Relleno azul después del borde (720ms + 150ms delay = 870ms)
    this.fillTimeout = setTimeout(() => {
      if (this.hasFillTarget) {
        this.fillTarget.classList.remove('opacity-0', 'scale-95')
        this.fillTarget.classList.add('opacity-100', 'scale-100')
      }
    }, 870)

    // Play negro después del relleno (870ms + 100ms = 970ms)
    this.playTimeout = setTimeout(() => {
      if (this.hasPlayTarget) {
        this.playTarget.classList.remove('opacity-0', 'scale-70')
        this.playTarget.classList.add('opacity-100', 'scale-100')
      }
    }, 970)
  }

  handleMouseLeave() {
    // Solo se dispara cuando el mouse sale completamente de la card
    // Validar que todos los targets existen antes de proceder
    if (!this.hasAllTargets()) return

    // Cancelar timeouts de relleno y play
    if (this.fillTimeout) clearTimeout(this.fillTimeout)
    if (this.playTimeout) clearTimeout(this.playTimeout)

    // Ocultar relleno y play inmediatamente
    if (this.hasFillTarget) {
      this.fillTarget.classList.add('opacity-0', 'scale-95')
      this.fillTarget.classList.remove('opacity-100', 'scale-100')
    }
    if (this.hasPlayTarget) {
      this.playTarget.classList.add('opacity-0', 'scale-70')
      this.playTarget.classList.remove('opacity-100', 'scale-100')
    }

    // Desdibujar en orden inverso: left → bottom → right → top (180ms cada uno)
    this.cancelAnimations()
    this.animateLine(this.leftTarget, 0, 180, true)
    this.animateLine(this.bottomTarget, 180, 180, true)
    this.animateLine(this.rightTarget, 360, 180, true)
    this.animateLine(this.topTarget, 540, 180, true)
  }

  hasAllTargets() {
    return this.hasTopTarget && this.hasRightTarget && this.hasBottomTarget &&
           this.hasLeftTarget && this.hasFillTarget && this.hasPlayTarget
  }

  animateLine(element, delay, duration, reverse = false) {
    if (!element) return
    const animation = element.animate(
      [
        { strokeDashoffset: reverse ? 0 : 40 },
        { strokeDashoffset: reverse ? 40 : 0 }
      ],
      {
        duration: duration,
        delay: delay,
        easing: 'ease-out',
        fill: 'forwards'
      }
    )
    this.currentAnimations.push(animation)
  }

  cancelAnimations() {
    this.currentAnimations = this.currentAnimations || []
    this.currentAnimations.forEach(anim => anim.cancel())
    this.currentAnimations = []
  }
}
